
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator"
import { TemplateDetails } from "@/types"
import TemplateInheritanceChain from "./TemplateInheritanceChain.vue"

@Component({
	components: {
		"template-inheritance-chain": TemplateInheritanceChain
	}
})
export default class TemplateInheritanceChangeSummaryModal extends Vue {
	@Prop()
	rootTemplate!: TemplateDetails;
	@Prop()
	affected?: { fieldIds?: Set<string>; sectionIds?: Set<string> }
	@Prop()
	showModal: boolean = false;

	private isOpen: boolean = false;

	@Watch("showModal")
	onShowModalChange (newValue: boolean) {
		this.isOpen = newValue
	}

	get showModalValue () {
		return this.isOpen
	}

	set showModalValue (value: boolean) {
		this.isOpen = value
		if (!value) {
			// Modal was closed, emit cancelled if it wasn't confirmed
			this.cancel()
		}
	}

	public confirm () {
		this.isOpen = false
		this.$emit("confirmed", this.rootTemplate)
	}

	public cancel () {
		this.isOpen = false
		this.$emit("cancelled")
	}
}
